module.exports = __webpack_public_path__ + "static/media/chevron.a1ec4be6.svg";